<template>
  <div>
    <b-modal ref="model_ql" title="提示" ok-title="确定" ok-only>
      <p>申请状态异常，请联系银行</p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "BaseApplyAction",
  data() {
    return {
      bankSerialNumber: "",
      bankCode: "",
      cardTheme: "",
      modifyPicture: "" //重新上传图片
    };
  },
  mounted: function() {
    this.bankSerialNumber = this.$route.query.bankSerialNumber;
    console.log("bankSerialNumber:" + this.bankSerialNumber);
    this.modifyPicture = this.$route.query.modifyPicture;
    console.log("bankSerialNumber:" + this.modifyPicture);
    this.bankCode = this.$route.query.bankCode;
    console.log("bankCode:" + this.bankCode);

    this.cardTheme = this.$route.params.cardTheme;
    console.log("cardTheme:" + this.cardTheme);
    if (this.cardTheme !== undefined) {
      this.cardTheme = JSON.parse(this.cardTheme);
    }

    this.routeToBybankCode();
  },
  methods: {
    routeToBybankCode: function() {
      if (config.isSczhBank(this.bankCode)) {
        //四川中行
        console.log("四川中行");
        this.toSichuanZhonghang();
      } else if (config.isQiluBank(this.bankCode)) {
        console.log("齐鲁银行");
        var applyDetail = this.$route.query.applyDetail;
        console.log("applyDetail:" + applyDetail);
        this.decodeData(applyDetail);
      } else if (config.isShzhnshBank(this.bankCode)) {
        console.log("深圳农商行");
        this.toShzhnshBank();
      } else if (config.isSchtnfBank(this.bankCode)) {
        console.log("四川天府银行");
        this.toSchtnfBank();
      } else if (config.isSchmyshBank(this.bankCode)) {
        console.log("四川绵阳商行");
        this.toSchmyshBank();
      } else if (config.isHunanBank(this.bankCode)) {
        console.log("湖南银行");
        console.log("bankCode:" + this.bankCode);
        this.tohunanbank();
      } else {
        console.log("非四川银行");
        console.log("bankCode:" + this.bankCode);
      }
    },
    // 湖南银行
    tohunanbank: function() {
      this.$router.replace({
        name: "Agreement",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          modifyPicture: this.modifyPicture
        }
      });
    },
    toSichuanZhonghang: function() {
      this.$router.replace({
        name: "SelectCardface_sczh",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          cardTheme: this.cardTheme
        }
      });
    },
    toQiluBank: function(applyInfo) {
      this.$router.replace({
        name: "SelectCardface_ql",
        params: {
          ...applyInfo
        }
      });
    },
    toShzhnshBank: function() {
      let customModel = this.$route.query.customModel;
      console.log("customModel:" + customModel);
      let cardTypeCode = this.$route.query.cardTypeCode;
      console.log("cardTypeCode:" + cardTypeCode);
      let nameCode = this.$route.query.nameCode;
      console.log("nameCode:" + nameCode);
      this.$router.replace({
        name: "SelectCardface_shzhnsh",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          customModel: customModel,
          cardTypeCode: cardTypeCode,
          nameCode: nameCode
        }
      });
    },
    decodeData: function(input) {
      // console.log('object', encodeURIComponent("PZ0oVvriGPjiZlcx5BcWLX52DLo+al8ocICsPrMdS7sgf3p3t8T6zKPmujQsjtGGkmWEm+f8vd9MvBhG18wY0wqv32uuI9ohSK01aW7DgN9y7QxptGWZP6fWPGFasSwBY62D8GSZPnWFBQsfTb6B3V997+HhARNPLeCAIZAjxaDuWIYCPROV0InhBIjTMO8VInoyGPFBDLfVAdpJGHbQD5lJgyuku+OUzloRd4w3Fj1vt2APkz5VasQzLFVAf0DTppTzljOXqetAZk5/DWjVbKwneBzDWETAfTy+4vjpQRINAl0NhhBjn6oiDUzuoKiSgUpknytFIgtMs0hJV2smzg=="))

      let newinput = encodeURIComponent(input);
      //解密数据
      // console.log("********decodeData********")
      var that = this;

      var formData = new FormData();
      formData.append("applyDetail", newinput);
      axios({
        method: "post",
        url: config.config_ql.getDecodeData,
        data: formData
      })
        .then(function(response) {
          // console.log(response)
          //{"checkStatus":"0","merchNo":"01B1","mobileNo":"xx","flowNo":"500000000757468"}
          if (response.status == 200) {
            let data = response.data;
            if (data.checkStatus == "2") {
              that.showQlStateMsg();
              return;
            } else if (data.checkStatus == "0" || data.checkStatus == "1") {
              let params = data; // JSON.stringify(data);
              //申请卡页面
              console.log("data", data);
              that.toQiluBank(params); //跳转到齐鲁银行选择卡面页面
            }
          } else {
          }
          let dataRes = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showQlStateMsg: function() {
      this.$refs["model_ql"].show();
    },
    toSchtnfBank: function() {
      //四川天府银行
      //参数的值 0- 第一次上传  1-重新上传  2-补卡
      let type = this.$route.query.type;
      let orderNo = this.$route.query.orderNo;
      this.$router.replace({
        name: "SelectCardface_schtnf",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          type: type,
          orderNo: orderNo
        }
      });
    },
    toSchmyshBank: function() {
      //四川绵阳商行
      //DIY卡类型: 000：默认001：萌宠
      let cardTypeFromBank = this.$route.query.CardType;
      let cardSubject = 99;
      if (cardTypeFromBank == "000") {
        //无限卡主题
        cardSubject = 99;
      } else if (cardTypeFromBank == "001") {
        //宠物卡主题
        cardSubject = 1;
      }
      this.$router.replace({
        name: "SelectCardface_schmysh",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          CardType: cardSubject
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/base/BaseApplyAction.vue